<template>
  <div>
    <!-- Inner Header -->
    <section class="py-5 bg-white inner-header">
      <div class="container">
        <div class="row">
          <div class="col-md-12 text-center">
            <div v-if="isPaymentSuccessful">
              <div class="payment-success-icon payment-status">
                 <div class="success-tick"></div>
              </div>
             
              <h1 class="mt-0 mb-3 text-green" v-if="isPaymentSuccessful">
                Your Payment was Successful
              </h1>
              <p v-if="isPaymentSuccessful">
                Thank you for your payment An automated receipt will be sent to
                your registered email.
              </p>
            </div>
            <div v-else>
              <div class="payment-error-icon payment-status">
                <p>!</p>
              </div>
              <h1 class="mt-0 mb-3 text-green">
                Your Payment was unsuccessful
              </h1>
              <p>
                There seems to be something wrong with the payment. Try again.
              </p>
            </div>
            <div class="">
              <div class="button">  
                <router-link
                  :to="`/dashboard`"
                  class="button gutter"
                  >Back to Dashboard </router-link
                >
                <router-link :to="`/dashboard/jobs/postnewjob`" class="button"
                  >Create new project</router-link
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- End Inner Header -->
  </div>
</template>

<script>
import { VERIFY_PROJECT_PAYMENT } from "../../../core/config/endpoints/project-payment";
import { getCall } from "../../../core/services/http.service";
export default {
  data() {
    return {
      isPaymentSuccessful: "",
      paymentStatus: "",
      projectId: null
    };
  },
  mounted() {
    this.verifyPayment();
  }, 
  methods: {
    verifyPayment() {
      this.$store.commit("setIsLoaded", true);
      getCall(
        VERIFY_PROJECT_PAYMENT.VERIFY({
          trxref: this.$route.query.txref,
          reference: this.$route.query.reference,
        })
      )
        .then((response) => {
          if (response.status === 200) {
            this.isPaymentSuccessful = true;
            this.projectId = response.data.data.id
            this.paymentStatus = "successful";
          } else {
            this.isPaymentSuccessful = false;
          }
        })
        .catch((error) => {
          this.$toast.error(`${error.response.data.message}`);
        })
        .finally(() => {
          this.$store.commit("setIsLoaded", false);
        });
    },
  },
};
</script>

<style scoped>
.payment-status{
  width: 60px;
  height: 60px;
  border-radius: 50%;
   margin: 0 auto;
   display: flex;
  align-items: center;
}
.payment-error-icon {
  border: 1px solid var(--orange);
}
.payment-error-icon p {
  margin: 0 auto;
  font-size: 30px;
  color: var(--orange);
}
.success-tick {
    position: relative;
    display: inline-block;
    width: 30px;
    height: 30px;
    margin: 0 auto;
}
.payment-success-icon{
  border: 1px solid var(--green);
}
.success-tick::before {
    position: absolute;
    left: 0;
    top: 50%;
    height: 50%;
    width: 3px;
    background-color: var(--green);
    content: "";
    transform: translateX(10px) rotate(-45deg);
    transform-origin: left bottom;
}

.success-tick::after {
    position: absolute;
    left: 0;
    bottom: 0;
    height: 3px;
    width: 100%;
    background-color: var(--green);
    content: "";
    transform: translateX(10px) rotate(-45deg);
    transform-origin: left bottom;
}
</style>

